import { atom } from "jotai";

export const modalDetailProject = atom({
      isOpen : false,
      item : null
})